module.exports = __webpack_public_path__ + "img/placeOfShipment1.e658f077.png";